import React, { useEffect, useState, useRef } from "react";
import CustomSelect from "../../utils/CustomSelect";

const AddUserConversationPopup = ({ users = [], InConvUsers, onClose, onAdd }) => {
    const [listUsersSelected, setSelectedUsers] = useState([]);
    const popupRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    useEffect(() => {
        if (users.length > 0 && InConvUsers?.length >= 0) {
            const excludedUUIDs = new Set(InConvUsers.map((u) => u.UUID_));

            setSelectedUsers(
                users
                    .filter((u) => !excludedUUIDs.has(u.UUID_))
                    .map((u) => ({
                        UUID_: u.UUID_,
                        Nom: u.Nom,
                        Email: u.Email,
                        selected: false,
                    }))
            );
        }
    }, [users, InConvUsers]);

    const handleUsersSelectionChange = (nom) => {
        setSelectedUsers((prev) =>
            prev.map((user) =>
                user.Nom === nom ? { ...user, selected: !user.selected } : user
            )
        );
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const selectedUUIDs = listUsersSelected.filter((u) => u.selected).map((u) => u.UUID_);
        if (selectedUUIDs.length > 0) {
            onAdd(selectedUUIDs);
            setSelectedUsers((prev) =>
                prev.map((user) => ({ ...user, selected: false }))
            );
            onClose();
        }
    };

    return (
        <div
            ref={popupRef}
            className="top-16 -right-5 z-50 absolute bg-gray-800 shadow-md px-4 py-4 rounded-xl w-72 text-white text-sm"
        >
            <h3 className="mb-2 font-semibold text-white text-sm">Ajouter des utilisateurs</h3>

            <CustomSelect
                value={`Utilisateurs sélectionnés (${listUsersSelected.filter((u) => u.selected).length})`}
                options={listUsersSelected}
                onChange={handleUsersSelectionChange}
                multiple={true}
                className="bg-gray-700 rounded-lg text-gray-300 text-sm hover:placeholder-gray-300 placeholder-gray-500"
                classNameIn="bg-gray-700 text-gray-300 hover:bg-gray-600"
            />

            <div className="flex justify-end gap-2 mt-4">
                <button
                    onClick={handleSubmit}
                    className="bg-orange-600 hover:bg-orange-500 px-3 py-1 rounded text-white text-sm"
                >
                    Ajouter
                </button>
            </div>
        </div>

    );
};

export default AddUserConversationPopup;